import OrderApi from "api/OrderApi";

class AliPay {
  async pay(data) {
    const orderData = await this.createOrder(data)
    if(orderData.code != 20000) return
    const {url} = orderData.data
    window.location.replace(url)
  }
  createOrder(data) {
    data = {
      ...data,
      pay_type: 'ali_pay',
      app_id: '2021001163628298',
      order_type: 1,
      trade_type: 'MWEB'
    }
    return OrderApi.createNewOrder(data) 
  }
}

export default new AliPay()